/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useMemo } from "react";
import {
    Card,
    CardBody,
    CardHeader
} from "reactstrap";
import Loader from "../../Components/Common/Loader";
import ForeCastPreviewCardHeader from "../../Components/Common/ForeCastPreviewCardHeader";
import { postDataAPI } from "../../helpers/phpbackend_helper";
import { FLASH } from "../../helpers/data_helper";
import { TrendAvgCheckCoverChart } from "./TrendAvgCheckCoverChart";

const TrendAvgCheckCover = ({ mealPeriod, leftFilter }) => {
    const [forecastAjax, setForecastAjax] = useState(false);
    const [start_dt, setstart_dt] = useState("");
    const [end_dt, setend_dt] = useState("");
    const [forecastData, setForecastData] = useState({
        covers_actual: [],
        covers_ly: [],
        avg_check_actual: [],
        avg_check_ly: [],
        months: [],
        covers_max: 0,
        avg_check_max: 0
    });

    let date = new Date();
    date.setDate(date.getDate() - 1);

    let date_second = new Date();
    date_second.setDate(date_second.getDate() - 1);

    useEffect(() => {
        setForecastAjax(true);
        postDataAPI({
            serviceName: FLASH.serviceName,
            op: FLASH.op_trending_cover_avgcheck,
            leftFilter: leftFilter,
            mealPeriod: mealPeriod
        }).then((response) => {
            setForecastAjax(false);
            if (response.status === "ok") {
                //console.log(response.data.data);                                           
                setForecastData({
                    covers_actual: response.data.data.covers_actual || [],
                    months: response.data.data.months || [],
                    covers_ly: response.data.data.covers_ly || [],
                    avg_check_actual: response.data.data.avg_check_actual || [],
                    avg_check_ly: response.data.data.avg_check_ly || [],
                    covers_max: Number(response.data.data.covers_max) || 0,
                    avg_check_max: Number(response.data.data.avg_check_max) || 0,
                });
                setstart_dt(response.data.data.start_dt);
                setend_dt(response.data.data.end_dt);
            } else {
                // console.log(response);
            }
        });

    }, [mealPeriod, leftFilter]);

    return (
        <React.Fragment>
            <Card>
                <ForeCastPreviewCardHeader
                    title={<div className="d-flex align-items-start">
                        <div className={`icon-box rounded bg-danger text-white`}>
                            <i className="ri-list-check"></i>
                        </div>
                        <div className="ps-2">
                            <h4 className="card-title mb-1">
                                Average Check / Covers
                            </h4>
                            <p className="text-muted mb-0">
                                Monthly view of covers and average check vs last year.
                            </p>
                        </div>
                    </div>}
                    toggleText="Show Table"
                />
                <CardBody>
                    {forecastAjax && <Loader />}
                    <div id="TrendAvgCheckCover" className={forecastAjax ? "opacity-0" : ""}>
                        <div className="live-preview">
                            <TrendAvgCheckCoverChart
                                forecastData={forecastData}
                                dataColors='["--vz-primary", "--vz-danger", "--vz-success", "--vz-warning", "--vz-info", "--vz-dark"]'
                                start_dt={start_dt}
                                end_dt={end_dt}
                            />
                        </div>
                        <div className="d-none code-view">
                            <div className="table-responsive table-card">
                                <table className="table table-borderless table-centered align-middle table-nowrap mb-0">
                                    <thead className="text-muted table-light">
                                        <tr>
                                            <th scope="col">Months</th>
                                            <th scope="col">Actual</th>
                                            <th scope="col">Last Year</th>
                                            <th scope="col">Avg Check Actual</th>
                                            <th scope="col">Avg Check Last Year</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {(forecastData.months || []).map(
                                            (item, key) => {
                                                return (
                                                    <tr key={key}>
                                                        <td>
                                                            {forecastData.months[key]}
                                                        </td>
                                                        <td>
                                                            {forecastData.covers_actual[key] ?? ""}
                                                        </td>
                                                        <td>
                                                            {forecastData.covers_ly[key] ?? ""}
                                                        </td>
                                                        <td>
                                                            {forecastData.avg_check_actual[key] ?? ""}
                                                        </td>
                                                        <td>
                                                            {forecastData.avg_check_ly[key] ?? ""}
                                                        </td>
                                                    </tr>
                                                );
                                            }
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </CardBody>
            </Card>
        </React.Fragment>
    );
};

export default TrendAvgCheckCover;
